module.exports = __webpack_public_path__ + "slide-4-qdZ.jpg";